// import WorkIm from '../assets/projects/workImg.jpeg'
// import RealEst from '../assets/projects/realestate.jpg'
import reactCart from '../assets/projects/react-redux-cart.png'
import Connect_4 from '../assets/projects/Connect_4_In_Python.png'
import Anime from '../assets/projects/Anime-Search-React.png'
import WeatherApp from '../assets/projects/Weather_App_JS.png'
import Tick_Tack_Toe from '../assets/projects/Flutter_Tick_Tack_toe_Game.png'
import Github_Api from '../assets/projects/All-Github-Closed-Pull-Request.png'
import Drum_Kit from '../assets/projects/Drum_Kit.png'

export const data=[
    {
        id:1,
        name:"React JS Cart",
        image:reactCart,
        github:"https://github.com/abhay-tomar03/React-Redux-Cart",
        live:"https://react-redux-cart09.netlify.app/",
    },
    {
        id:2,
        name:"Popular Anime ReactJs Application",
        image:Anime,
        github:"https://github.com/abhay-tomar03/Anime_Search_Info",
        live:"https://popular-anime-search.netlify.app/",
    },
    {
        id:3,
        name:"Weather App",
        image:WeatherApp,
        github:"https://github.com/abhay-tomar03/Weather-App",
        live:"https://abhay-tomar03.github.io/Weather-App/",
    },
    {
       id:4,
        name:"Connect 4 Game Python",
        image:Connect_4,
        github:"https://github.com/abhay-tomar03/Connect_4_Game_Python",
        live:"",
    },
    {
        id:5,
        name:"Flutter Tick Tack Toe Game",
        image:Tick_Tack_Toe,
        github:"https://github.com/abhay-tomar03/FLutter-Tic-Tac-Toe-Game",
        live:"",
    },
    {
       id:6,
        name:"Flutter Github Closed PR",
        image:Github_Api,
        github:"https://github.com/abhay-tomar03/-Pull-Request-GithubApi-App",
        live:"",
    },
    {
       id:7,
        name:"Drum Kit JS",
        image:Drum_Kit,
        github:"https://github.com/abhay-tomar03/drum-kit-website",
        live:"https://abhay-tomar03.github.io/drum-kit-website/",
    },


]